var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRechargeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.962,
    height: 25.663,
    viewBox: "0 0 15.962 25.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(-68.019 -562.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M29.03,6.574a1.263,1.263,0,0,0-1.353,1.148V29.541a1.263,1.263,0,0,0,1.353,1.148h11.5a1.263,1.263,0,0,0,1.353-1.148V7.722a1.263,1.263,0,0,0-1.353-1.148Zm0-.574h11.5a1.9,1.9,0,0,1,2.03,1.722V29.541a1.9,1.9,0,0,1-2.03,1.722H29.03A1.9,1.9,0,0,1,27,29.541V7.722A1.9,1.9,0,0,1,29.03,6Zm1.843.551h7.944a.411.411,0,0,0-.325.369h0a.733.733,0,0,1-.743.525H32.136a.92.92,0,0,1-.868-.525h0C31.226,6.818,31.153,6.551,30.872,6.551Z",
    transform: "translate(41.219 556.368)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_thunder_1512672",
    transform: "translate(123.731 586.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M8.489,3.833a.306.306,0,0,0-.258-.14H6.077V.308A.308.308,0,0,0,5.488.183L3.026,5.721a.308.308,0,0,0,.281.433H5.462V9.538a.308.308,0,0,0,.244.3.328.328,0,0,0,.064.007.308.308,0,0,0,.281-.183L8.512,4.125A.307.307,0,0,0,8.489,3.833Z",
    transform: "translate(-53 -16)",
    fill: "#db5f28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeWhite);
export default __webpack_public_path__ + "static/media/recharge_white.5eb8285dd29e37a6d29a605cd4a1b9dd.svg";
export { ForwardRef as ReactComponent };